import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
// import star from '../../assets/img/cart/star.svg'
import heartBlack from '../../assets/img/cart/heart-black.svg'
import trash from '../../assets/img/cart/trash.svg'
import noImage from 'assets/img/profile.svg'
import api from '../../api/api'
import { ArrowCircleDown } from 'phosphor-react'
import { processError } from '../../lib/lib'
import Cookies from 'universal-cookie'
import Skeleton from '../UI/Skeleton'
const cookies = new Cookies()

class CatalogCard extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
            favorite: false,
        }
    }

    action(ids) {
        if (typeof this.props.action === 'function') {
            this.props.action(ids)
        }
    }

    favorite(courseId) {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        if (this.state.favorite)
            api.deleteFavorite({ token, lang, courseId })
                .then(() => this.setState({ favorite: false }))
                .catch((e) => processError(e, this.props.props.history))
        else
            api.postFavorite({ token, lang, courseId })
                .then(() => this.setState({ favorite: true }))
                .catch((e) => processError(e, this.props.props.history))
    }

    componentDidMount() {
        this.setState({ favorite: this.props.favorite })
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="cart__card d-flex align-items-stretch justify-content-between">
                            <div className="card__img_wrapper d-flex align-items-center justify-content-center">
                                <Skeleton image={true} width={150} height={150} />
                            </div>
                            <div className="card__content_wrapper d-flex flex-column align-items-start justify-content-between">
                                <div className="card__content_top w-100">
                                    <h6 className="card__title sm-font-size w-100"><Skeleton count={2} /></h6>
                                    <p className="card__description xs-font-size">{t('cart-personal-purchases')}</p>
                                </div>
                            </div>
                            <div className="card__action_wrapper d-flex flex-column align-items-center justify-content-between">
                                <p className="card__price md-font-size"><Skeleton /></p>
                                <Skeleton button={true} width={140} height={40} className="card__btn d-flex align-items-center justify-content-center" />
                                <Skeleton button={true} width={140} height={40} className="card__delete_btn card__btn d-flex align-items-center justify-content-center" />
                            </div>
                        </div>
                        :
                        <div className="cart__card d-flex align-items-stretch justify-content-between">
                            <div className="card__img_wrapper d-flex align-items-center justify-content-center">
                                <img src={this.props.image ? `${this.state.imageUrl}/${this.props.image}` : noImage} alt="" onClick={() => this.props.props.history.push(`/item/${this.props.id}`)} />
                            </div>
                            <div className="card__content_wrapper d-flex flex-column align-items-start justify-content-between">
                                <div className="card__content_top">
                                    <h6 className="card__title sm-font-size" onClick={() => this.props.props.history.push(`/item/${this.props.id}`)}>{this.props.title}</h6>
                                    {/* <div className="stars__wrapper d-flex align-items-center justify-content-start">
                            <img src={star} alt="star" />
                            <img src={star} alt="star" />
                            <img src={star} alt="star" />
                            <img src={star} alt="star" />
                            <img src={star} alt="star" />
                        </div> */}
                                    <p className="card__description xs-font-size">{t('cart-personal-purchases')}</p>
                                </div>
                                {/* <div className="card__content_bottom">
                        <p className="xs-font-size">{t('cart-active-until')}</p>
                    </div> */}
                            </div>
                            <div className="card__action_wrapper d-flex flex-column align-items-center justify-content-between">
                                <p className="card__price md-font-size">{this.props.newPrice} {this.props.currency}</p>
                                <div className="card__btn d-flex align-items-center justify-content-center" onClick={() => this.favorite(this.props.id)}>
                                    <img src={heartBlack} alt="heart" />
                                    <p className="sm-font-size">{this.state.favorite ? t('cart-from-favorite') : t('cart-to-favorites')}</p>
                                </div>
                                {
                                    this.props.delete ?
                                        <div className="card__delete_btn card__btn d-flex align-items-center justify-content-center" onClick={() => this.action([this.props.id])}>
                                            <img src={trash} alt="trash" />
                                            <p className="sm-font-size">{t('cart-delete')}</p>
                                        </div> :
                                        <div className="card__add_btn card__btn d-flex align-items-center justify-content-center" onClick={() => this.action([this.props.id])}>
                                            <ArrowCircleDown className="circle-down-icon" size={20} color={'#ffffff'} />
                                            <p className="sm-font-size">{t('cart-add')}</p>
                                        </div>
                                }
                            </div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

CatalogCard.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    add: PropTypes.bool,
    delete: PropTypes.bool,
    id: PropTypes.string,
    props: PropTypes.object,
    image: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    tags: PropTypes.array,
    partners: PropTypes.array,
    totalPartners: PropTypes.number,
    likes: PropTypes.number,
    oldPrice: PropTypes.number,
    newPrice: PropTypes.number,
    action: PropTypes.func,
    favorite: PropTypes.favorite,
    skeleton: PropTypes.bool,
    currency: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
}

export default withTranslation()(CatalogCard)



// WEBPACK FOOTER //
// ./src/components/Cart/CartItem.jsx